import React from 'react'
import PropTypes from 'prop-types'
import constants from '../../../../components/constants'

const NotFoundErro = ({ title, message, imageUrl }) => {
  return (
    <div className="w-full flex items-center justify-center overflow-hidden">
    <div className="flex flex-col gap-5 items-center justify-start mt-20">
      <img src={imageUrl || constants.chips} alt="" />
  
      <div className="text-center">
        <h1 className="text-custom-gray font-bold">
          {title || 'Page Not Found'}
        </h1>
        <p className="text-[#5F6368] w-[400px]">
          {message || 'Looks like you don’t have any questions. Click on the button above to add one.'}
        </p>
      </div>
    </div>
  </div>
  )
}

NotFoundErro.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  imageUrl: PropTypes.string,
}

export default NotFoundErro